module.exports = __webpack_public_path__ + "img/team-1.df2f9f19.png";